import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "most-viewed-wrapper" }
const _hoisted_2 = { class: "type" }
const _hoisted_3 = { class: "name" }


export default /*@__PURE__*/_defineComponent({
  __name: 'MostViewedCardMolecule',
  props: {
    resource_name: {},
    resource_id: {},
    resource_type: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, "Top " + _toDisplayString(_ctx.resource_type), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.resource_name), 1)
  ]))
}
}

})